<script>
    export let fill = "#fff";
    export let size = 20;
</script>

<svg enable-background="new 0 0 403.2 380.8" version="1.1" viewBox="0 0 403.2 380.8" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"  width={size} height={size} fill={fill}>
    <path d="M0,0l123.2,41.1v336L0,336L0,0z M280,3.7l123.2,41.1v336L280,339.7V3.7z M257.6,3.7v336l-112,37.4v-336L257.6,3.7z"/>
</svg>    